// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JNCEiuwega2YRyLvd4q0qQ\\=\\={padding:.3rem}.SjyoJ0HSoy8Ra2vh-zrcTA\\=\\=,.JNCEiuwega2YRyLvd4q0qQ\\=\\={border:1px solid #ccc}", "",{"version":3,"sources":["webpack://./resources/src/components/CKEditor/CKEditor.module.scss"],"names":[],"mappings":"AAAA,4BACI,aAEJ,CAEA,wDAHI,qBAKJ","sourcesContent":[".wrapper-class {\n    padding: 0.3rem;\n    border: 1px solid #ccc;\n}\n\n.toolbar-class {\n    border: 1px solid #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper-class": "JNCEiuwega2YRyLvd4q0qQ==",
	"toolbar-class": "SjyoJ0HSoy8Ra2vh-zrcTA=="
};
export default ___CSS_LOADER_EXPORT___;
